module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "copy_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Girls_chap_1"
    }
  }, [_vm._v("Ruby & Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Girls_chap_2"
    }
  }, [_vm._v("Mother’s Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Girls_chap_3"
    }
  }, [_vm._v("Nature’s Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country Mice")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Writing & Deadlines")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holy Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birds & Feathers")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coots")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secret Life of Crows")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven’s Door")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mysterious Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Tranche")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concentric Circles")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Wedding Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remains")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The surprise party was amazing! Happy Birthday to us!")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peevo")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deadlines & Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Premonitions & Portents")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prosim")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Again, Home Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Writers and Baseball")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human Conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dead Men’s Ember")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_chap_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Writers & Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "ackn_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_ackn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "auth_bio_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Girls_auth_bio_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9471be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Girls_toc.vue
// module id = 63
// module chunks = 0